import * as moment from "moment-timezone";
import { DateTimeService } from "../Shared/DateTimeService";
import * as ContractDataSchema from "./Services/IContractData";

export class ContractTemplate {
    index: number;
    day: string;
    productCode: string;
    productDisplayName: string;
    originalDisplayName: string;
    deliveryStart: moment.Moment;
    deliveryEnd: moment.Moment;
    contractId: number;
    contractType: ContractDataSchema.ContractType;
    areas: Map<string, ContractArea>;

    constructor(data: ContractDataSchema.IContractData, dateTimeService: DateTimeService) {
        this.contractId = data.globalContractId;
        this.productCode = data.reportProductCode;
        this.productDisplayName = data.contractType === "CUSTOM_BLOCK" ? this.getBlockProductDisplayName(data.displayName) : data.displayName;
        this.originalDisplayName = data.displayName;
        this.areas = new Map<string, ContractArea>();
        this.deliveryStart = moment(data.contractDate);
        this.day = this.deliveryStart.tz(dateTimeService.currentTimeZone).format("ddd, D MMM YYYY");
        this.deliveryEnd = moment(data.deliveryEndDate);
        this.contractType = data.contractType;
    }

    private getBlockProductDisplayName(displayName: string): string {
        let modifiedName: string;
        const nameDetails: Array<String> = displayName.split("-");
        const startDay = Number(nameDetails[1].slice(6, 8));
        const endDay = Number(nameDetails[4].slice(6, 8));
        if (startDay === endDay) {
            modifiedName =
                nameDetails[0] + "-" + // letter part of name of the first product
                nameDetails[2] + "-" + // number part of name of the first product
                nameDetails[3] + "-" + // letter part of name of the last product
                nameDetails[5] + "/" + // number part of name of the last product
                nameDetails[1].slice(6, 8) + "." + // day of these products
                nameDetails[1].slice(4, 6); // month of theese prducts
        } else {
            modifiedName =
                nameDetails[0] + "-" + // letter part of name of the first product
                nameDetails[2] + "-" + // number part of name of the first product
                nameDetails[3] + "-" + // letter part of name of the last product
                nameDetails[5] + "/" + // number part of name of the last product
                nameDetails[1].slice(6, 8) + "-" + // first day of these products
                nameDetails[4].slice(6, 8) + "." + // last day of these products
                nameDetails[4].slice(4, 6); // month of theese prducts
        }
        return modifiedName;
    }

    getStatusText(area: string): ContractDataSchema.ContractStatus {
        const status = this.areas.get(area);

        return status ? status.status : "undefined";
    }

    isAreaSelected(area: string): boolean {
        const status = this.areas.get(area);

        return status ? status.selected : false;
    }

    getStyleClass(area: string): string {
        const statusText = this.getStatusText(area);
        const isSelected = this.isAreaSelected(area);
        let statusClass: string;

        switch (statusText) {
            case "EXPIRED":
            case "OPEN":
            case "CLOSED":
            case "NEW":
            case "FROZEN":
            case "BLOCKED":
                statusClass = `area-status-${statusText.toLowerCase()}`;
                break;
            default:
                statusClass = "area-status-undefined";
                break;
        }

        return statusClass + (isSelected ? " area-selected" : "");
    }
}

export class ContractTemplateGroup {
    rows: ContractTemplate[];
    day: string;
}

export class ContractArea {
    status: string;
    persistedStatus: string;
    selected: boolean;
    contractId: string;
    marketAreaCode: string;
    tenantId: string;
}

export enum ContractStatusEnum {
    NEW = 0,
    OPEN = 2,
    CLOSED = 3,
    EXPIRED = 4,
    FROZEN = 5,
    BLOCKED = 6
}

export enum ContractState {
    OPEN,
    CLOSE
}



// WEBPACK FOOTER //
// ./src/app/ContractManagement/ContractDataModels.ts